import { useCalendarContext } from '@/domain/termine/features/Calendar/shared/CalendarContext';
import { ListWeekHeader } from '@/domain/termine/features/Calendar/List/ListWeekHeader';
import { Day } from '@/domain/termine/type';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { ListDay } from '@/domain/termine/features/Calendar/List/ListDay';

interface ListWeekProps {
  week: Day[];
  currentMonth: number;
  currentYear: number;
}

export function ListWeek({ week, currentMonth, currentYear }: ListWeekProps) {
  const { feiertage, termineByDay } = useCalendarContext();
  const { t } = useTranslation();

  const daysInSelectedMonth = week.filter(
    (day) => day.month() + 1 === currentMonth && day.year() === currentYear,
  );

  const weekHasFeiertag = daysInSelectedMonth.some((day: Day) =>
    feiertage.some((f) => dayjs(f.datum).isSame(day, 'day')),
  );

  const weekHasTermine = daysInSelectedMonth.some((day) => {
    const termine = termineByDay.get(day.format('YYYY-MM-DD')) ?? [];
    return termine.length > 0;
  });

  const showNoTermine = !weekHasFeiertag && !weekHasTermine;

  return (
    <div className="rounded-xl">
      <ListWeekHeader week={week} />
      {showNoTermine ? (
        <span>{t('domain.termine.keineTermine')}</span>
      ) : (
        daysInSelectedMonth.map((day) => (
          <ListDay
            key={day.format('DD-MM-YYYY')}
            day={day}
            week={week}
            currentMonth={currentMonth}
            currentYear={currentYear}
          />
        ))
      )}
    </div>
  );
}
